// extracted by mini-css-extract-plugin
export default {"zippingThumb":"dHv4U5"};